import { render, staticRenderFns } from "./PieChartChannelsArrangementFee.vue?vue&type=template&id=4bed3d16&"
import script from "./PieChartChannelsArrangementFee.vue?vue&type=script&lang=js&"
export * from "./PieChartChannelsArrangementFee.vue?vue&type=script&lang=js&"
import style0 from "./PieChartChannelsArrangementFee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports